// src/components/ui/Button.js
import React from 'react';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  onClick 
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-medium transition-all duration-200 rounded-full cursor-pointer';
  
  const variants = {
    primary: 'bg-blue-700 text-white hover:bg-blue-600',
    secondary: 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-600/10',
    outline: 'bg-transparent border border-blue-600 text-blue-600 hover:bg-blue-600/10'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;